import { render, staticRenderFns } from "./TrainingUserSide.vue?vue&type=template&id=46b641b2&scoped=true&"
import script from "./TrainingUserSide.vue?vue&type=script&lang=js&"
export * from "./TrainingUserSide.vue?vue&type=script&lang=js&"
import style0 from "./TrainingUserSide.vue?vue&type=style&index=0&id=46b641b2&lang=scss&scoped=true&"
import style1 from "./TrainingUserSide.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b641b2",
  null
  
)

export default component.exports